import { __assign, __rest } from "tslib";
import { createBasePlugin } from 'wix-rich-content-common';
import createTextToolsToolbar from './toolbar/createTextToolsToolbar';
import { TEXT_TOOLS_TYPE } from './types';
import createStyles from 'draft-js-custom-styles';
var customStyleMap = {};
var createTextToolsPlugin = function (config) {
    if (config === void 0) { config = {}; }
    var type = TEXT_TOOLS_TYPE;
    var _a = createStyles(['color'], type + "_", customStyleMap), styles = _a.styles, customStyleFn = _a.customStyleFn;
    // Pass it into config so we can use the modifiers
    config.customStylesPlugin = styles;
    var _b = config, theme = _b.theme, anchorTarget = _b.anchorTarget, relValue = _b.relValue, _c = type, _d = _b[_c], settings = _d === void 0 ? {} : _d, rest = __rest(_b, ["theme", "anchorTarget", "relValue", typeof _c === "symbol" ? _c : _c + ""]);
    var toolbar = createTextToolsToolbar(config);
    return createBasePlugin(__assign({ theme: theme,
        toolbar: toolbar,
        type: type,
        anchorTarget: anchorTarget,
        relValue: relValue,
        settings: settings }, rest), { customStyleFn: customStyleFn });
};
export { createTextToolsPlugin };
//# sourceMappingURL=createTextToolsPlugin.js.map